import { render, staticRenderFns } from "./ClientAccessHome.vue?vue&type=template&id=87fd4dee&"
import script from "./ClientAccessHome.vue?vue&type=script&lang=js&"
export * from "./ClientAccessHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports